import _ from 'lodash';
import Dotdotdot from 'react-dotdotdot';
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';

import connect from 'components/lib/connect';
import { default as ConversationModel } from 'models/conversation';
import NavigateToConversation from 'actions/conversation/navigate_to_conversation';
import ShortLongDate from 'components/lib/date/short_long_date';

export function Conversation({ conversation, onClickConversation, topicNames }) {
  const today = new Date();
  const dateCreated = new Date(conversation.createdAt);
  const displayFullMonth = dateCreated.getFullYear() === today.getFullYear();

  const label = getLabel() || '';
  const displayTooltip = label.length > 25; // One line fits approx. 25 characters

  return (
    <div className="conversationNav-conversation" onClick={onClickConversation}>
      <div className="conversationNav-conversation-icon">
        <FontAwesomeIcon icon={faCalendarAlt} />
      </div>
      <div className="conversationNav-conversation-timestamp">
        <ShortLongDate displayFullMonth={displayFullMonth} timestamp={conversation.createdAt} />
      </div>
      <div className="conversationNav-conversation-label" title={displayTooltip ? label : null}>
        <Dotdotdot clamp={3}>{label}</Dotdotdot>
      </div>
    </div>
  );

  function getLabel() {
    if (!topicNames.length) {
      return _.upperFirst(conversation.status.toLowerCase());
    }
    return topicNames.join(', ');
  }
}

Conversation.propTypes = {
  conversation: PropTypes.instanceOf(ConversationModel),
  customerId: PropTypes.string.isRequired,
  onClickConversation: PropTypes.func.isRequired,
  topicNames: PropTypes.arrayOf(PropTypes.string).isRequired,
};

function mapStateToProps({ getProvider }, { conversation }) {
  const topicNames =
    (conversation &&
      _(conversation.topicIds)
        .map(id => {
          let t = getProvider('topics').findBy({ id });
          return t ? t.name : null;
        })
        .compact()
        .value()) ||
    [];

  return {
    conversation,
    topicNames,
  };
}

function mapExecuteToProps(executeAction, { customerId, conversation }) {
  return {
    onClickConversation: () => executeAction(NavigateToConversation, { customerId, conversationId: conversation.id }),
  };
}

const ConversationContainer = connect(mapStateToProps, mapExecuteToProps)(Conversation);

ConversationContainer.propTypes = {
  conversation: PropTypes.instanceOf(ConversationModel).isRequired,
  customerId: PropTypes.string.isRequired,
};

export default ConversationContainer;
